import { observable, makeObservable, action, makeAutoObservable } from "mobx";
import { Store } from "../common/store";
export class AppStateStore extends Store {
    apiBasePath;
    activeGroup;
    user;
    constructor() {
        super(null);
        makeObservable(this, {
            apiBasePath: observable,
            activeGroup: observable,
            user: observable,
            setAPIBasePath: action,
            setActiveGroup: action,
            setUser: action,
        });
    }
    setRoot(root) {
        super.setRoot(root);
    }
    setAPIBasePath(apiBasePath) {
        this.apiBasePath = apiBasePath;
    }
    setActiveGroup(group) {
        this.activeGroup = group;
    }
    setUser(user) {
        this.user = user;
    }
}
export class User {
    id;
    name;
    groups;
    constructor(id, name, groups) {
        makeAutoObservable(this);
        this.id = id;
        this.name = name;
        this.groups.push(...groups);
    }
}
export class Group {
    id;
    name;
    constructor(id, name) {
        makeAutoObservable(this);
        this.id = id;
        this.name = name;
    }
}
//# sourceMappingURL=store.js.map